export const TYPE_INIT_MESSAGE_WITH_PORT = 'init-connection';

export const SUPPORTED_PARENT_FRAMES = ['messenger', 'meeting-room'] as const;
